import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {ILoginCallbackStore} from './login-callback.stores';
import {IAppRootStore} from '../../app.root.store';

interface LoginCallbackViewProps {
    loginCallbackStore: ILoginCallbackStore;
    rootStore: IAppRootStore;
}

@observer
export class LoginCallbackViewComponent extends TechseeBaseComponent<LoginCallbackViewProps> {
    renderInternal(): JSX.Element {
        return <div>Redirecting...</div>;
    }
}

export const LoginCallbackView = inject(
    'rootStore',
    'loginCallbackStore'
)(LoginCallbackViewComponent) as IReactComponent;
